import { debug } from "util";

/* eslint-disable */
export default class AttributesService {
    constructor(urls, sendRequest) {
        if (urls == null)
            throw new Error('urls cannot be null');
        
        if (sendRequest == null || typeof(sendRequest) !== 'function')
            throw new Error('sendRequest must be Function');
        
        this._urls = urls;
        this._sendRequest = sendRequest;
    }

    async getAttributes(request) {
        if (this._isKkmAttribute(request)) {
            const url = `${this._urls.baseUrl}/api/ccms/${request.kkmId}/attributes`;
            return await this._sendRequest(url, request);
        }
        
        return await this._sendRequest(this._urls.getSysAttributes, request);
    }

    async updateAttribute(request) {
        if (this._isKkmAttribute(request)) {
            const url = `${this._urls.baseUrl}/api/ccms/${request.kkmId}/attribute`;

            return await this._sendRequest(url, request, 'PUT');
        }

        return await this._sendRequest(this._urls.updateSysAttribute, request);
    }

    async setDefaultValue(request) {
        if (this._isKkmAttribute(request)) {
            const url = `${this._urls.baseUrl}/api/ccms/${request.kkmId}/attribute`;
            
            request.isDefault = true;
            
            return await this._sendRequest(url, request, "PUT");
        }
    }

    _isKkmAttribute(request) {
        return request.kkmId != null;
    }
} 